export default __webpack_public_path__ + "static/cash-icon-0e2a1bea5081119d4a1ffef1832e36de.png";